export default {
    isLoggedIn: false,
    user: null,
}